// Day74 URGENT hotfix (2026-07-22 22:00 area・代表 direct GO):
// tutorial_progress migration + server API endpoint 本番未 deploy のため
// axios GET /api/staff/tutorial/progress が全 clientMaster で 404 →
// EMPTY_STATE fallback → isFresh=true → WelcomeModal 誤発火中。
// 再構築 (server migration + API deploy + client hook 冪等化) までは
// mount 自体を停止する。previous impl は git log 90f29b63 参照。
export function TutorialWrapper() {
  return null;
}
